import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { setActiveModalAction } from '../../../action';
import { fromStore } from '../../../selectors';
import moment from 'moment';
import { MEASURES_RAW } from '../../rawmaterials/constansts';
import { parseNumToFixed } from '../../../utils/common';

export function ParamsSemi() {
    const dispatch = useDispatch();
    const detail = useSelector(fromStore.detailRawSelector);

    const onOpenModalEditGood = (e) => {
        e.stopPropagation();
        const rawId = detail.id || 'new';
        dispatch(setActiveModalAction({ field: 'modalRaw', value: { id: rawId, type: 'semi' } }));
    };

    return (
        <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <h3 className="kt-portlet__head-title">
                        Информация о полуфабрикате
                    </h3>
                </div>
            </div>
            <div className="kt-form kt-form--label-right">
                <div className="kt-portlet__body" style={{ minHeight: '350px' }}>
                    <div className="form-group form-group-xs row">
                        <div className="col-4 col-form-label">Название:</div>
                        <div className="col-8">
                            <span className="form-control-plaintext kt-font-bolder">{detail.name}</span>
                        </div>
                    </div>
                    <div className="form-group form-group-xs row">
                        <div className="col-4 col-form-label">Категория:</div>
                        <div className="col-8">
                            <span className="form-control-plaintext kt-font-bolder">{detail.productscategory.title}</span>
                        </div>
                    </div>
                    <div className="form-group form-group-xs row">
                        <div className="col-4 col-form-label">ID Категории:</div>
                        <div className="col-8">
                            <span className="form-control-plaintext kt-font-bolder">{detail.productscategory.id}</span>
                        </div>
                    </div>
                    <div className="form-group form-group-xs row">
                        <div className="col-4 col-form-label">Вес/Объем:</div>
                        <div className="col-8">
                            <span className="form-control-plaintext kt-font-bolder">{parseNumToFixed(detail.weight, 3)} {MEASURES_RAW[detail.measure]}</span>
                        </div>
                    </div>
                    <div className="form-group form-group-xs row">
                        <div className="col-4 col-form-label">Создан:</div>
                        <div className="col-8">
                            <span className="form-control-plaintext kt-font-bolder">{moment(detail.created_at).format('DD.MM.YYYY в HH:mm')}</span>
                        </div>
                    </div>
                    <div className="form-group form-group-xs row">
                        <div className="col-4 col-form-label">Обновлен:</div>
                        <div className="col-8">
                            <span className="form-control-plaintext kt-font-bolder">{moment(detail.updated_at).format('DD.MM.YYYY в HH:mm')}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className="kt-portlet__foot">
                <div className="kt-form__actions kt-space-between">
                    <button onClick={onOpenModalEditGood} className="btn btn-label-brand btn-sm btn-bold">Редактировать</button>
                </div>
            </div>
        </div>
    );
}